<template>
<div>
    <div class="main container" v-if="$route.name == 'cookies'">
        <h3 class="title mt-3 title-2">{{ $t('cookies') }}</h3>
        <h4 class="subtitle subtitle-padding">Vad är en cookie?</h4>
        <p class="text-light-w justify-content">
            När vi pratar om cookies på internet menar vi små textfiler som sparas på din dator eller
            enhet, via din webbläsare, när du besöker en webbplats. Informationen i en cookie berättar
            saker för webbplatsen, som till exempel:
        </p>
        <ul class="text-light-w">
            <li>om du besökt webbplatsen tidigare</li>
            <li>om du har ett konto som du valt att förbli inloggad på </li>
            <li>om du har påbörjat en ansökan men inte avslutat den </li>
        </ul>
        <h4 class="subtitle subtitle-padding">Hur använder vi cookies?</h4>
        <p class="text-light-w justify-content">
            Vi använder oss av lokal lagring av data, vilket innebär att olika typer data lagras lokalt på
            din enhet (t.ex. dator, mobiltelefon eller surfplatta) via din webbläsare. En typ av lokal lagring
            av data är cookies. En cookie är en liten textfil som lagras på din enhet (t.ex. dator,
            mobiltelefon eller surfplatta) vilken gör det möjligt för oss att känna igen din webbläsare.
            Cookies innehåller ingen direkt identifierbar information avseende dig (så som namn,
            adress, telefonnummer etc.) utan endast information om din webbläsare och den aktivitet
            som har skett genom webbläsaren. Vi använder oss också av andra liknande tekniker
            såsom pixeltaggar. Dessa är tekniker som kan känna igen cookies och andra identifierare
            och som gör det möjligt för tredje parter att placera cookies i din enhet. I detta dokument
            används termen ”lokal lagring av data” som ett samlingsnamn för cookies, pixeltaggar och
            annan liknande teknik. <br>
            <br>
            Viss lokal lagring av data är nödvändig för att du ska kunna använda Familjekortets tjänst.
            Detta gäller till exempel information om dina inställningar, vilket visar oss hur frågorna ska
            presenteras i din webbläsare. Lokal lagring av data används också för att vi ska kunna
            anpassa våra tjänster så bra som möjligt efter din användning, exempelvis för att lagra vilka
            inställningar som du vill ha vid uppspelning av ljud, för att lagra information om vilken
            videokvalitet som passar din webbläsare och internethastighet och för specialfunktioner
            såsom möjligheten att spara ifyllda uppgifter. Nödvändiga cookies används också för att vi
            ska kunna erbjuda livechatt till dig som besöker Familjekortets hemsida. Vi använder också
            olika mätverktyg som ger oss statistik och analyser avseende beteende på Familjekortets
            hemsida för att vi ska kunna ge dig en personligt anpassad upplevelse. Vidare använder vi
            information vi har samlat in och analyserat för att utveckla och förbättra Familjekortets
            hemsida och för att kontrollera att den fungerar som den ska.
        </p>
        <h4 class="subtitle subtitle-padding">Kan du själv styra användningen av cookies?</h4>
        <p class="text-light-w justify-content container-padding">
            Ja. Du kan hantera cookies i din webbläsare, antingen genom att rensa bort befintliga
            cookies eller genom att förhindra att nya cookies sparas. De flesta webbläsare erbjuder även
            ett anonymt läge som förhindrar att cookies sparas under en viss webbläsarsession. Se din
            webbläsares hjälpavsnitt för ytterligare information. <br>
            <br>
            Kom ihåg att cookies enbart gäller för en enskild webbläsare på en viss enhet. Om du till
            exempel sätter regler för eller raderar cookies på Chrome på din mobiltelefon kommer dessa
            ändringar inte att verkställas i Firefox på din bärbara dator.<br>
            <br>
            Mer information om hur man stänger av cookies finns i instruktionerna till din webbläsare.
        </p>
    </div>

    <div class="main container" v-if="$route.name == 'membership-terms'">
        <h3 class="title mt-3 title-2">{{ $t('membership-terms') }}</h3>
        <p class="text-light-w justify-content subtitle-padding">
            Vad kul att du vill bli medlem! Nu kommer du helt gratis att få tillgång till massor med grymma
            erbjudanden och rabatter! Var snäll och börja med att läsa igenom och godkänna dessa
            medlemsvillkor som gäller för alla våra medlemmar.
        </p>
        <h4 class="subtitle subtitle-padding">Medlemskap</h4>
        <p class="text-light-w justify-content">
            Du blir enkelt medlem genom att ange informationen som efterfrågas vid registreringen. Ditt
            medlemskap är personligt och du ansvarar för att de uppgifter som du fyller i är korrekta, samt att de
            uppdateras i den mån du önskar. Om du anger felaktiga uppgifter vid registreringen, kan det medföra
            att ditt konto blir raderat. Var försiktig med dina inloggningsuppgifter och hantera dem på ett säkert
            sätt. Som medlem är du ytterst ansvarig för dina inloggningsuppgifter. Genom att godkänna dessa
            medlemsvillkor förbinder du dig också till att inte missbruka sajten eller medlemskapet genom att
            exempelvis skicka spam eller virus. Familjekortet Sverige AB har rätt att granska ditt medlemskonto
            om det misstänks att villkoren missbrukas. Medlem som inte uppfyller villkoren kan utan förvarning få
            sitt medlemskap avslutat.
        </p>
        <h4 class="subtitle subtitle-padding">Extra för dig som medlem</h4>
        <p class="text-light-w justify-content">
            Som medlem hos Familjekortet får du möjlighet att ta del av olika kampanjer, erbjudanden och rabatter
            från de företag som är anslutna till Familjekortet. Du får även tillgång till Mina Sidor, där du själv kan
            välja att komplettera dina kontaktuppgifter och ange intressen och födelsedagar för dig och dina barn.
            Vi ges då till exempel möjlighet att uppvakta er extra på födelsedagar. Som medlem kan du även få
            personligt anpassat innehåll på sajten och relevanta och utvalda erbjudanden som anpassats för dig
            utifrån dels ditt användande av sajten, men även hur du tidigare utnyttjat erbjudanden och rabatter.<br>
            <br>
            Vi kommunicerar vanligtvis via e-post, pushnotiser och andra digitala kanaler, som exempelvis
            annonsering på vår egen och externa webbsidor (t.ex. Facebook), men ibland kommunicerar vi även
            via t.ex. sms, Messenger, WhatsApp och brev. Du kan när som helst kontakta oss via vårt <router-link :to="{ name: 'contact' }">kontaktformulär</router-link>. Det kan även bli möjligt
            att göra personliga inställningar på Mina sidor, gällande hur du önskar att vi kommunicerar med dig.
            Vi kan inte kan hjälpa till med ändringar som gäller begränsningar när det gäller sociala nätverk. Det
            behöver du på egen hand ändra i inställningarna på respektive konto.
        </p>
        <h4 class="subtitle subtitle-padding">Avsluta ditt medlemskap</h4>
        <p class="text-light-w justify-content">
            Ditt medlemskap hos oss gäller tills vidare, men du kan när som helst avsluta ditt medlemskap
            genom att höra av dig till vår kundtjänst via vårt <router-link :to="{ name: 'contact' }">kontaktformulär</router-link>. Om du väljer att avsluta ditt
            medlemskap raderas ditt konto. Om du inte har loggat in, handlat, eller över huvud taget interagerat
            med oss (genom att exempelvis kontakta kundtjänst) på ca. 36 månader kommer ditt medlemskap
            automatiskt att avslutas. Ditt medlemskap kan också avslutas av oss om du brutit mot
            medlemsvillkoren, eller på annat sätt missbrukat ditt medlemskap.
        </p>
        <h4 class="subtitle subtitle-padding">Ändringar av medlemsvillkor</h4>
        <p class="text-light-w justify-content">
            Familjekortet förbehåller sig rätten att göra ändringar i dessa medlemsvillkor när som helst i tiden.
            Alla ändringar av dessa medlemsvillkor kommer att publiceras på familjekortet.se, eller skickas ut via
            e-post. Vi rekommenderar dock att du håller dig uppdaterad på familjekortet.se regelbundet för att se
            om det sker eventuella ändringar av medlemsvillkoren.
        </p>
        <h4 class="subtitle subtitle-padding">Hur hanterar vi dina personuppgifter?</h4>
        <p class="text-light-w justify-content">
            För att ge dig en bästa möjlig upplevelse, så kan vi komma att personalisera sajten utifrån hur du
            interagerar med oss och vad vi tror att du tycker om. För att lyckas med detta behöver vi hantera och
            administrera dina personuppgifter. Mer information om hur vi behandlar dessa uppgifter hittar du i vår
            <router-link :to="{ name: 'integrity-policy' }">integritetspolicy</router-link>.
        </p>
        <h4 class="subtitle subtitle-padding">Frågor?</h4>
        <p class="text-light-w justify-content container-padding">
            Har du några som helst frågor om medlemskapet är du alltid välkommen att höra av dig till oss via vårt <router-link :to="{ name: 'contact' }">kontaktformulär</router-link>.
        </p>
    </div>

    <div class="main container" v-if="$route.name == 'integrity-policy'">
        <h3 class="title mt-3 title-2">{{ $t('integrity-policy') }}</h3>
        <p class="text-light-w justify-content subtitle-padding">
            Vi på Familjekortet är måna om att värna och respektera integriteten för de personer som är
            medlemmar hos oss, samt de företag och dess privata företrädare som interagerar med oss.
        </p>
        <h4 class="subtitle subtitle-padding">Vi behandlar personuppgifter av flera skäl:</h4>
        <p class="text-light-w justify-content">
            <ul class="text-light-w">
                <li>För att förbättra användarupplevelsen kring våra tjänster och våra digitala kanaler, samt för att
                    kunna besvara förfrågningar till vår kundservice</li>
                <li>I syfte att uppfylla våra skyldigheter enligt lagar, myndighetsföreskrifter och förordningar</li>
                <li>För att effektivt kunna genomföra kreditbedömningsprocesser (företag)</li>
                <li>Kartläggning av insamlad data för att skapa en förståelse för marknadstrender i syfte att
                    utveckla och förbättra vår marknadsföring och våra tjänster</li>
            </ul>
        </p>
        <h4 class="subtitle subtitle-padding">Insamlingen av personuppgifter sker vid olika tillfällen:</h4>
        <span class="text-light-w justify-content">
            Gällande digitala kanaler kan det
            exempelvis ske när personen begär att bli kontaktad, registrerar sig för nyhetsbrev, eller
            kontaktar Familjekortet via e-post. Familjekortet kan även komma att samla in personuppgifter via
            andra ej digitala kanaler, exempelvis under telefonsamtal eller fysiska möten. Vidare kan
            Familjekortet komma att samla in personuppgifter från marknadsförings partners, publika
            databaser, sociala medier, kreditupplysningsföretag och andra samarbetspartners.
        </span>
        <h4 class="subtitle subtitle-padding">Personuppgifter som Familjekortet samlar in från företag: </h4>
        <span class="text-light-w justify-content">
            Familjekortet samlar in den information som lämnas vid och kring ordertillfället. I samband med detta samlas följande
            kategorier av personuppgifter in: Namn, adress, telefonnummer, e-post, personnummer och/eller
            organisationsnummer, eventuella betalningsanmärkningar och skuldsaldo hos
            Kronofogdemyndigheten, samt eventuell annan finansiell information kring företag och dess
            företrädare.
        </span>
        <h4 class="subtitle subtitle-padding">Personuppgifter som Familjekortet samlar in från privatpersoner (medlemmar):</h4>
        <p class="text-light-w justify-content">
            Familjekortet samlar in den information som lämnas vid registrering av medlemskap, eller vid
            senare tillfälle på Mina sidor. Detta kan till exempel vara personnummer, adress, e-post,
            telefonnummer, personnummer, namn på barn och deras personnummer.
        </p>
        <h4 class="subtitle subtitle-padding">Användning av insamlade personuppgifter:</h4>
        <p class="text-light-w justify-content">
            Familjekortet använder personuppgifterna för intern administration, fullgörande av avtal,
            marknadsföringssyften, säkerhetsändamål, förbättringsåtgärder och för att svara på kunders
            frågor och önskemål, fastställande av identitet, kundkännedomskontroller, kreditbedömningar
            (företag).
        </p>
        <h4 class="subtitle subtitle-padding">För att kunna marknadsföra oss mot dig </h4>
        <p class="text-light-w justify-content">
            och visa våra produkter och erbjudanden både på vår
            sajt och genom samarbetspartners, hanterar vi de här uppgifterna om dig:
             <ul class="text-light-w">
                 <li>IP-adresser</li>
                 <li>Data som samlats in ifrån cookies och liknande, exempelvis vilka erbjudanden och
                    företag du klickat på, sidor du har besökt och om du kommit till vår sajt via exempelvis en
                    annons</li>
             </ul>
            För att göra detta använder vi oss av olika externa annonstjänster och samarbetspartners.
        </p>
        <h4 class="subtitle subtitle-padding">För att kunna erbjuda dig en personifierad sajt</h4>
        <p class="text-light-w justify-content">
            som ger dig bästa möjliga upplevelse och ger dig mer relevanta visningar och rekommendationer, behandlar vi de här uppgifterna om dig:
            <ul class="text-light-w">
                 <li>IP-adresser</li>
                 <li>Data som samlats in ifrån cookies och liknande, exempelvis vilka erbjudanden och
                    företag som du klickat på och din historik gällande utnyttjande av erbjudanden</li>
            </ul>
            Den här datan analyserar vi och ger dig sedan förslag på andra erbjudanden eller företag du
            kanske skulle tycka om på vår sajt. Detta gör vi med ditt samtycke som du ger i cookie-bannern
            på vår sajt. Om du vill kan du rensa din cookiedata, vilket tar bort all historik.
        </p>
        <h4 class="subtitle subtitle-padding">Skydd av personuppgifter</h4>
        <p class="text-light-w justify-content">
            Familjekortet genomför löpande organisatoriska, tekniska och administrativa åtgärder i syfte att
            skydda personuppgifter från otillbörlig åtkomst, förstörelse eller förändring. Har du anledning att
            misstänka att interaktionen med Familjekortet inte är säker, kontakta oss omgående.
        </p>
        <h4 class="subtitle subtitle-padding">Tid för lagring av personuppgifter</h4>
        <p class="text-light-w justify-content">
            Familjekortet behåller och sparar endast personuppgifter under den tid det är nödvändigt för att
            uppfylla ändamålen beskrivna i denna integritetspolicy samt för uppfyllelse av Familjekortets
            skyldigheter enligt lagstiftning. Vid den tidpunkt då uppgifterna saknar relevans enligt ovan
            kommer de att raderas alternativt anonymiseras.
        </p>
        <h4 class="subtitle subtitle-padding">Delning av persondata till tredje part</h4>
        <p class="text-light-w justify-content">
            Familjekortet delar inte personuppgifter till tredje part, med följande undantag: Till
            samarbetspartner för marknadsföringsåtgärder; till kreditupplysningsföretag (gäller Företag); till
            leverantörer vid relevans att kunna tillhandahålla tjänster (exempelvis IT-system); vid eventuell
            försäljning av hela eller delar av Familjekortets verksamhet, eller vid fall där tredje part övertar
            låneavtal eller andra fordringar.
        </p>
        <h4 class="subtitle subtitle-padding">Rättslig grund</h4>
        <p class="text-light-w justify-content">
            Rättslig grund för behandlingen av personuppgifter baserar sig på att
            personuppgiftsbehandlingen är nödvändig för fullgörande av en rättslig förpliktelse enligt tillämplig
            lagstiftning, exempelvis bokföringslagen eller att personuppgiftsbehandlingen är nödvändig för att
            fullgöra avtalet mellan Familjekortet och avtalspart.
        </p>
        <h4 class="subtitle subtitle-padding">Rättigheter</h4>
        <p class="text-light-w justify-content">
            En privatperson, ett företag eller dess företrädare har rätt att invända mot behandling av
            personuppgifter i marknadsföringssyfte. Invändningar sker genom kontakt till Familjekortet per
            e-post eller post enligt nedan kontaktuppgifter. Rättigheter innefattar även rätten att begära
            tillgång till personuppgifter, begära rättelse eller radering/begränsning av behandlingen av
            personuppgifter. Du har också rätt att lämna in eventuella klagomål gällande Familjekortets
            behandling av dina personuppgifter till behörig tillsynsmyndighet; Datainspektionen.
        </p>
        <h4 class="subtitle subtitle-padding">Begränsning av integritetspolicyn</h4>
        <p class="text-light-w justify-content">
           Integritetspolicyn omfattar inte hantering av personuppgifter via tredjepart som Familjekortet inte
           äger eller kontrollerar eller för personer som inte har ett avtal med, eller är anställda, av
           Familjekortet.
        </p>
        <h4 class="subtitle subtitle-padding">Kontaktuppgifter</h4>
        <p class="text-light-w justify-content container-padding">
            Familjekortet värnar om din integritet och du är välkommen att kontakta oss vid frågor eller
            eventuella klagomål kring insamling och användning av personuppgifter via post till: Familjekortet
            Sverige AB, Österlånggatan 69, 503 37 Borås eller via vårt <router-link :to="{ name: 'contact' }">kontaktformulär</router-link>.
        </p>
    </div>
    <router-link class="btn btn-danger cookies-button " :to="{name: 'all-campaigns'}">{{ $t('all_discounts') }}</router-link>
    </div>
</template>
<script>
export default {
    mounted() {
  window.scrollTo(0, 0);
    },

    metaInfo() {
        const titles = {
            'cookies': 'Cookiepolicy',
            'integrity-policy': 'Integrity Policy',
            'membership-terms':'Membership Terms',
        };

        return {
            title: titles[this.$route.name] + ' - Familjekortet',
        };
    }
}
</script>
